import { trackEvent } from "@/lib/audit";

export type RetentionMode = "live" | "halftime" | "no_match" | "inactive";

export interface ModeContext {
  minute?: number;
  isLive?: boolean;
  lastActiveAt?: number; // ms epoch
}

export const PRIORITIES: Record<RetentionMode, string[]> = {
  live: ["live_tracker", "match_ai", "advanced_stats", "community_chat", "betting_odds", "sponsored_surveys", "rewards"],
  halftime: ["halftime_hub", "trivia", "fantasy", "rewards", "sponsor_offers"],
  no_match: ["daily_fantasy", "quiniela_express", "trivia_battles", "traditional_stats", "h2h_intelligence", "global_oracle", "rewards_marketplace"],
  inactive: ["match_reminders", "reward_reminders", "trivia_invitations", "sponsor_offers"],
};

const INACTIVITY_MS = 1000 * 60 * 60 * 24 * 2; // 48h

export function detectMode(ctx: ModeContext = {}): RetentionMode {
  const { minute, isLive, lastActiveAt } = ctx;
  if (lastActiveAt && Date.now() - lastActiveAt > INACTIVITY_MS) return "inactive";
  if (isLive && typeof minute === "number") {
    if (minute >= 45 && minute <= 46) return "halftime";
    if (minute >= 1 && minute <= 95) return "live";
  }
  return "no_match";
}

const MODE_KEY = "ss2026_retention_mode";

export function trackModeIfChanged(mode: RetentionMode) {
  if (typeof window === "undefined") return;
  const prev = localStorage.getItem(MODE_KEY);
  if (prev === mode) return;
  localStorage.setItem(MODE_KEY, mode);
  void trackEvent("retention_mode_entered", { mode, prev });
}

export function getPriorities(mode: RetentionMode) { return PRIORITIES[mode]; }